import './account-selector-modal'
import './dependencies-tree'
import './inline-template-editing'
import './ledger-copier'
import './liquid-profiler'
import './live-inputs'
import './markdown-datepicker'
import './save-changes'
import './starring'
import './template-test-editor'
import './copy-reconciliation-data-modal'
import setupStatusCarousel from './setup-status-carousel'
import setupMarkAsFinalized from './mark-as-finalized'
import setupNavigationCarousel from './setup-navigation-carousel'
import setupTemplateActionsDropdown from './template-actions-dropdown'
import setupInsightsLink from './insights-link'

setupStatusCarousel()
setupMarkAsFinalized()
setupNavigationCarousel()
setupTemplateActionsDropdown()
setupInsightsLink()
